import React from "react";
import {
  INITIAL_WORK_ORDER_FILTERS,
  toWorkOrderFiltersForm,
  useWorkOrderFiltersParams,
} from "../../../../features/work-order";
import type { WorkOrderFiltersForm } from "../../../../features/work-order";
import { useIsMobile } from "../../../../shared/hooks/useIsMobile";
import type { WorkOrderFilterLayoutProps } from "../model/filterLayout.types";
import { WorkOrderFilterBarDesktop } from "./WorkOrderFilterBarDesktop";
import { WorkOrderFilterBarMobile } from "./WorkOrderFilterBarMobile";

/**
 * Owns the filter URL state; the layout that renders it is chosen by viewport.
 *
 * The two are swapped in JS rather than shown and hidden with CSS: rendering both would put a
 * second copy of all nine controls in the DOM, and every input would then answer to the same label.
 */
export const WorkOrderFilterBar: React.FC = () => {
  const [params, setParams] = useWorkOrderFiltersParams();
  const isMobile = useIsMobile();

  const filters = toWorkOrderFiltersForm(params);

  const handlers: Omit<WorkOrderFilterLayoutProps, "filters"> = {
    onFieldChange: (key, value) => void setParams({ ...filters, [key]: value }),

    onSortChange: (sortField, sortDirection) =>
      void setParams({ ...filters, sortField, sortDirection }),

    onGewerkChange: (gewerkId) => void setParams({ ...filters, gewerkId }),

    onStatusChange: (status) => void setParams({ ...filters, status }),

    // Sort is not a filter — clearing the fields should not also throw away the column the list is
    // ordered by.
    onReset: () =>
      void setParams({
        ...INITIAL_WORK_ORDER_FILTERS,
        sortField: filters.sortField,
        sortDirection: filters.sortDirection,
      } satisfies WorkOrderFiltersForm),
  };

  const Layout = isMobile ? WorkOrderFilterBarMobile : WorkOrderFilterBarDesktop;

  return <Layout filters={filters} {...handlers} />;
};
